// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-0271c081] {\n  fill: currentColor;\n  stroke-width: 0;\n  stroke: currentColor;\n}", ""]);
// Exports
module.exports = exports;
